import { useState, useEffect } from 'react';
import {
  Typography,
  MenuItem,
  RadioGroup,
  FormLabel,
  FormControl,
  FormControlLabel,
} from '@mui/material';

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '../../../../../components/common/Accordion';
import {
  TextField,
  Grid,
  Button,
  GreenSlider,
  GreenRadio,
  CustomInput,
} from '../../../../../components/common';
import colors from '../../../../../assets/colors';
import { marks } from '../../../../../assets/consts';
import AccordionFormContext from '../../../../../store/accordion-form-context';
import { useContext } from 'react';

export default function CreditTerms(props) {
  const accordionCTX = useContext(AccordionFormContext);
  const [firstStageButtonDisabled, setFirstStageButtonDisabled] =
    useState(true);

  const handleLoanAmountChange = (event) => {
    accordionCTX.changeFormValue('loanAmount', event.target.value);
  };
  const handleLoanTypeChange = (event) => {
    accordionCTX.changeFormValue('loanType', event.target.value);
  };
  const handleIsTakingPaymentsChange = (event) => {
    accordionCTX.changeFormValue('isTakingDirectPayments', event.target.value);
  };
  const handleLoanLengthChange = (event) => {
    accordionCTX.changeFormValue('loanLength', event.target.value);
    event.stopPropagation();
  };

  useEffect(() => {
    if (
      !(
        accordionCTX.form.loanAmount.length < 1 ||
        accordionCTX.form.loanType.length < 1 ||
        accordionCTX.form.isTakingDirectPayments.length < 1 ||
        parseInt(accordionCTX.form.loanAmount) < 999
      ) &&
      Number.isInteger(parseInt(accordionCTX.form.loanAmount)) &&
      accordionCTX.form.isTakingDirectPayments === 'yes'
    ) {
      setFirstStageButtonDisabled(false);
    } else {
      setFirstStageButtonDisabled(true);
    }
  }, [
    accordionCTX.form.loanAmount,
    accordionCTX.form.loanType,
    accordionCTX.form.loanLength,
    accordionCTX.form.isTakingDirectPayments,
  ]);

  return (
    <Accordion
      square
      expanded={accordionCTX.navigation.expanded === 'panel1'}
      onChange={() => accordionCTX.changeNavigation('CHANGE', 'panel1')}
    >
      <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
        <h1>1. Warunki kredytowania</h1>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              margin="normal"
              value={accordionCTX.form.loanAmount}
              required
              fullWidth
              id="creditAmount"
              label="Wpisz kwotę kredytu"
              name="creditAmount"
              onChange={handleLoanAmountChange}
              autoFocus
              type="number"
              error={
                parseInt(accordionCTX.form.loanAmount) < 999 ||
                accordionCTX.form.loanAmount.length < 1
                  ? false
                  : !Number.isInteger(parseInt(accordionCTX.form.loanAmount))
              }
              helperText={
                accordionCTX.form.loanAmount.length >= 1 &&
                Number.isInteger(parseInt(accordionCTX.form.loanAmount))
                  ? parseInt(accordionCTX.form.loanAmount) < 999 &&
                    'Minimalna wielkość kredytu to 1000 zł'
                  : 'Podana wartość nie jest liczbą całkowitą!'
              }
            />
          </Grid>
          <Grid topMargin item xs={12}>
            <TextField
              bordered
              select
              fullWidth
              variant="outlined"
              label="Wybierz cel kredytu"
              value={accordionCTX.form.loanType}
              onChange={handleLoanTypeChange}
              sx={{
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: colors.oldAgroweGreen,
                  color: colors.black,
                },
                '& .MuiOutlinedInput-input': {
                  color: colors.black,
                },
              }}
              input={<CustomInput />}
            >
              <MenuItem value={'equipment'}>Sprzęt</MenuItem>
              <MenuItem value={'realEstate'}>Nieruchomości</MenuItem>
              <MenuItem value={'revolvingLoan'}>Kredyt obrotowy</MenuItem>
            </TextField>
          </Grid>
          <Grid topMargin item xs={12}>
            <TextField
              variant="outlined"
              margin="normal"
              disabled
              fullWidth
              id="product"
              label="Wybierz produkt"
              name="product"
              autoComplete="product"
            />
          </Grid>
          <Grid topMargin item xs={12}>
            <FormControl component="fieldset">
              <FormLabel component="legend">
                Czy otrzymujesz dopłaty bezpośrednie?
              </FormLabel>
              <RadioGroup
                aria-label="isTaking"
                name="gender1"
                value={accordionCTX.form.isTakingDirectPayments}
                onChange={handleIsTakingPaymentsChange}
              >
                <FormControlLabel
                  value="yes"
                  control={<GreenRadio />}
                  label="Tak"
                />
                <FormControlLabel
                  value="no"
                  control={<GreenRadio />}
                  label="Nie"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid topMargin item xs={12}>
            <Typography id="slider" gutterBottom>
              Wybierz okres kredytowania:
            </Typography>
            <GreenSlider
              value={accordionCTX.form.loanLength}
              defaultValue={4}
              onChange={handleLoanLengthChange}
              aria-labelledby="discrete-slider"
              valueLabelDisplay="auto"
              step={1}
              marks={marks}
              min={1}
              max={8}
            />
          </Grid>
          <Grid topMargin container justifyContent="center" alignItems="center">
            <Button
              variant="contained"
              disabled={firstStageButtonDisabled}
              onClick={() => accordionCTX.changeNavigation('UNLOCK', 'panel2')}
            >
              Sprawdź czy mamy kredyt dla Ciebie
            </Button>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
